import { makeEnvironmentProviders } from '@angular/core';
import { ClaimsAuthzCtxParserService, ClaimsAuthzService, WhiteListDataService } from '@mri-platform/resource-authz';
import { AngularResourceAuthzConfig } from './angular-resource-authz-config';
import { ResourceAuthzSessionService } from './resource-authz-session.service';

export function provideResourceAuthz(config?: AngularResourceAuthzConfig | undefined) {
  return makeEnvironmentProviders([
    ClaimsAuthzCtxParserService,
    WhiteListDataService,
    {
      provide: ClaimsAuthzService,
      useFactory: (parserService: ClaimsAuthzCtxParserService, whitelistDataService: WhiteListDataService) =>
        new ClaimsAuthzService(parserService, whitelistDataService),
      deps: [ClaimsAuthzCtxParserService, WhiteListDataService]
    },
    config ? [{ provide: ResourceAuthzSessionService, useClass: config.sessionServiceType }] : []
  ]);
}
